import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "../App.css";
import logoLight from "../obr/FCA_App_black2.png";
import logoDark from "../obr/FCA_App_gold2.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");

  const nacitajTemu = () => {
    const ulozena = localStorage.getItem("tema");
    return ulozena === "dark" ? "dark" : "light";
  };

  const [tema] = useState(nacitajTemu);
  const aktualneLogo = tema === "light" ? logoLight : logoDark;

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", tema);
  }, [tema]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const vysledok = await login(email, pwd);
      if (vysledok?.onboarding === true) {
        nav("/prve-spustenie", { replace: true });
        return;
      }

      nav("/app", { replace: true });

    } catch (e) {
      setErr(e.message || "Prihlásenie zlyhalo.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-logo-wrap">
          <img
            src={aktualneLogo}
            alt="FinCloud"
            className="login-logo"
          />
        </div>

        <div className="App login-app">
          <div className="card-section login-card">
            <h2>Prihlásenie</h2>

            <form onSubmit={onSubmit} className="form-group">
              <div className="form form--full">
                <label className="form_label">Email</label>
                <input
                  className="form_input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {err && <div className="form_hint error">{err}</div>}
              </div>

              <div className="form form--full">
                <label className="form_label">Heslo</label>
                <input
                  className="form_input"
                  type="password"
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                />
              </div>

              <div className="form-actions form-actions--full">
                <button
                  type="submit"
                  className="form_input action-btn"
                >
                  Prihlásiť
                </button>

                <Link
                  to="/zabudnute-heslo"
                  className="login-forgot-link"
                >
                  Zabudli ste heslo?
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}